import { GetRandomNumber } from "../helper/common";

export type THorse = {
    Name: string;
    Stamina: number; // from a max of 100
    Water: number; // from a max of 50
    TiedUp: boolean; // if the horse is tied up, it will drink water
    Feeding: boolean; // if the horse is feeding, it will eat food
    East: boolean; // if the horse is facing east or west
    // might later have speed settings, not sure. may also have other things such as shoe, saddle, etc.
    // might also have a 'type' that will affect speed, stamina, etc.
}

export function generateRandomHorseName(): string {
    const horseNames = ["Biscuit", "Shadow", "Thunder", "Lightning", "Blaze", "Spirit", "Whisper", "Dusty", "Rusty", "Midnight", "Star", "Duke", "Duchess", "Ranger", "Rider"];
    return horseNames[GetRandomNumber(horseNames.length)];
}